"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_HEADERS = void 0;
var tslib_1 = require("tslib");
exports.DEFAULT_HEADERS = {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, OPTIONS',
    'Access-Control-Allow-Headers': 'Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token,x-ntfos-Set-ClientId,x-ntfos-Authorization,CognitoAccessToken,Accept,Accept-Encoding,Referer,x-honeycomb-trace',
};
var formatResponse = function (_a) {
    var payload = _a.payload, statusCode = _a.statusCode, _b = _a.headers, headers = _b === void 0 ? {} : _b, cookies = _a.cookies, _c = _a.isBase64Encoded, isBase64Encoded = _c === void 0 ? false : _c;
    var body = typeof payload === 'string' ? payload : JSON.stringify(payload);
    return {
        isBase64Encoded: isBase64Encoded,
        statusCode: statusCode,
        body: body,
        headers: (0, tslib_1.__assign)((0, tslib_1.__assign)({}, exports.DEFAULT_HEADERS), headers),
        cookies: cookies,
    };
};
exports.default = formatResponse;
